import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Vector3d } from "./Vector3d";
export var Vector = /*#__PURE__*/function (_Vector3d) {
  _inherits(Vector, _Vector3d);

  var _super = _createSuper(Vector);

  function Vector(xOrCoords, y) {
    _classCallCheck(this, Vector);

    return _super.call(this, xOrCoords, y, 0);
  }

  _createClass(Vector, null, [{
    key: "origin",
    get: function get() {
      return Vector.create(0, 0);
    }
  }, {
    key: "clone",
    value: function clone(source) {
      return Vector.create(source.x, source.y);
    }
  }, {
    key: "create",
    value: function create(x, y) {
      return new Vector(x, y);
    }
  }]);

  return Vector;
}(Vector3d);